import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { formatDateWithTime, formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { Details } from "../../services/babeAssociate.service";
import Breadcrums from "../../common/breadcrumbs";
import { Placeholder } from "rsuite";
import { BACKGROUND_CHECK_RESULT, BACKGROUND_CHECK_STATUS } from "../../../../utils/Constants";
import ShowSkyflowImage from "../../../common/ShowSkyflowImage";
import moment from 'moment';

const BabeAssociateView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loader, setLoader] = useState(true);

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Babe Associate"),
      url: "/admin/babe-associate/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];


  useEffect(() => {
    Details(params._id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
        setTimeout(() => setLoader(false), 500)
      })
      .catch((error) => {
        console.log("error=====>", error);
        setTimeout(() => setLoader(false), 500)
      });
  }, [params._id]);

  function formateServices(data) {
    let newData = [];
    data.forEach(service => {
      newData.push(...service.subcategorydata);
    });
    return newData;
  }
  const verificationBadgeClass = {
    PENDING: "badge-warning-light",   // 🟡 yellow
    VERIFIED: "badge-success-light",  // 🟢 green
    REJECTED: "badge-danger-light"    // 🔴 red
  };

  const verificationBadgeNewClass = {
    true: "badge-success-light",   
    false: "badge-danger-light"   
  };

  const verificationBadgeClassNew = {
    PENDING: "badge-danger-light",   // 🟡 yellow
    VERIFIED: "badge-success-light",  // 🟢 green
    REJECTED: "badge-danger-light"    // 🔴 red
  };


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("btn_view") + " " + t("Babe Associate")}</h6>
              </div>
              {!loader ? (
                <div className="row">
                  {showdefault && Object.keys(showdefault).length > 0 ? (
                    <div className="col-lg-12 form-group">
                      <table id="simple-table" className="table  table-bordered table-hover">
                        <tbody>
                          <tr>
                            <th>{t("label_profile_image")}</th>
                            <td>
                              <ShowSkyflowImage table="users" column="associate_profile_image" skyflowID={showdefault.skyflow_id} elementID="" style={{ width: "100px", height: "100px" }} />
                            </td>
                          </tr>
                          <tr>
                            <th>{t("label_name")}</th>
                            <td className="text-capitalize">{showdefault && showdefault.name ? showdefault.name : "N/A"}</td>
                          </tr>

                          <tr>
                            <th>{t("list_heading_status")}</th>
                            <td className="text-capitalize">
                              {showdefault && showdefault.status && showdefault.status === 1 ? (
                                <span className="badge badge-pill badge-success-light">Active</span>
                              ) : (
                                <span className="badge badge-pill badge-danger-light">Blocked</span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th>Checker Status</th>
                            <td className="text-capitalize">
                              <span className={`badge badge-pill ${verificationBadgeClass[showdefault?.associate_verification_status] || "badge-secondary"}`}>
                                {showdefault?.associate_verification_status ? t(showdefault.associate_verification_status) : "pending"}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <th>RN Verification</th>
                            <td className="text-capitalize">
                              <span className={`badge badge-pill ${verificationBadgeNewClass[showdefault?.associate_profile_verification] || "badge-danger-light"}`}>
                                {showdefault?.associate_profile_verification ? t('VERIFIED') : t('NOT VERIFIED')}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <th>Massage License Verification</th>
                            <td className="text-capitalize">
                              <span className={`badge badge-pill ${verificationBadgeClassNew[showdefault?.associate_massage_license_status] || "badge-danger-light"}`}>
                                {showdefault?.associate_massage_license_status === 'VERIFIED' ? t('VERIFIED') : t('NOT VERIFIED')}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <th>Injection License Verification</th>
                            <td className="text-capitalize">
                              <span className={`badge badge-pill ${verificationBadgeClassNew[showdefault?.associate_license_status] || "badge-danger-light"}`}>
                                {showdefault?.associate_license_status === 'VERIFIED' ? t('VERIFIED') : t('NOT VERIFIED')}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <th>Background Check Request</th>
                            <td className="text-capitalize">
                              {showdefault && showdefault.checkrInvitationID && showdefault.checkrInvitationID.length ? (
                                <span className="badge badge-pill badge-success-light">Sent by user</span>
                              ) : (
                                <span className="badge badge-pill badge-danger-light">Not sent by user</span>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th>Background Check Status</th>
                            <td className="text-capitalize">
                              {(function () {
                                if (showdefault && showdefault.backgroundCheckStatus === BACKGROUND_CHECK_STATUS.PENDING) {
                                  return <span className="badge badge-pill badge-warning-light">Pending</span>;
                                } else if (showdefault && showdefault.backgroundCheckStatus === BACKGROUND_CHECK_STATUS.CANCELED) {
                                  return <span className="badge badge-pill badge-danger-light">Canceled</span>;
                                } else if (showdefault && showdefault.backgroundCheckStatus === BACKGROUND_CHECK_STATUS.IN_PROGRESS) {
                                  return <span className="badge badge-pill badge-danger-light">In Progress</span>;
                                } else if (showdefault && showdefault.backgroundCheckStatus === BACKGROUND_CHECK_STATUS.COMPLETE) {
                                  return <span className="badge badge-pill badge-success-light">Completed</span>;
                                } else if (showdefault && showdefault.backgroundCheckStatus === BACKGROUND_CHECK_STATUS.SUSPENDED) {
                                  return <span className="badge badge-pill badge-danger-light">Suspended</span>;
                                } else if (showdefault && showdefault.backgroundCheckStatus === BACKGROUND_CHECK_STATUS.DISPUTED) {
                                  return <span className="badge badge-pill badge-danger-light">Disputed</span>;
                                } else {
                                  return <span className="badge badge-pill badge-info-light">Unknown</span>;
                                }
                              })()}
                            </td>
                          </tr>
                          {showdefault && showdefault.backgroundCheckResult ? (
                            <tr>
                              <th>Background Check Result</th>
                              <td className="text-capitalize">
                                {(function () {
                                  if (showdefault && showdefault.backgroundCheckResult === BACKGROUND_CHECK_RESULT.CLEAR) {
                                    return <span className="badge badge-pill badge-success-light">Clear</span>;
                                  } else if (showdefault && showdefault.backgroundCheckResult === BACKGROUND_CHECK_RESULT.CONSIDER) {
                                    return <span className="badge badge-pill badge-danger-light">Consider</span>;
                                  } else if (showdefault && showdefault.backgroundCheckResult === BACKGROUND_CHECK_RESULT.PENDING) {
                                    return <span className="badge badge-pill badge-warning-light">Pending</span>;
                                  } else {
                                    return <span className="badge badge-pill badge-info-light">Unknown</span>;
                                  }
                                })()}
                              </td>
                            </tr>
                          ) : null}

                          <tr>
                            <th>{t("label_email")}</th>
                            <td>{showdefault && showdefault.email ? showdefault.email : "N/A"}</td>
                          </tr>

                          <tr>
                            <th>{t("label_address")}</th>
                            <td>{showdefault && showdefault.associate_address && showdefault.associate_address.address ? showdefault.associate_address.address : "N/A"}</td>
                          </tr>
                          <tr>
                            <th>{t("label_phone_number")}</th>
                            <td>{showdefault && showdefault?.phone_number ? showdefault.phone_number : "N/A"}</td>
                          </tr>

                          <tr>
                            <th>{t("label_associate_training_video_completion")}</th>
                            <td>
                              <div className="d-flex align-items-center">
                                <div class="progress" style={{ flex: 1 }}>
                                  <div
                                    class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                                    role="progressbar"
                                    aria-valuenow={showdefault.associate_training_video_completion}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                    style={{ width: `${showdefault.associate_training_video_completion}%` }}
                                  ></div>
                                </div>
                                <span style={{ display: "inline-block", width: "50px", textAlign: "center" }}>{showdefault.associate_training_video_completion}%</span>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th>Preferred Services</th>
                            <td>
                              <div className="d-flex flex-wrap d-grid gap-2">
                                {formateServices(showdefault.associate_preferred_services).map((item, index) => {
                                  return (
                                    <span className="badge badge-pill badge-info-light me-1" key={index}>
                                      {item.title}
                                    </span>
                                  );
                                })}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th>License Number</th>
                            <td>{showdefault.associate_license_number}</td>
                          </tr>
                          <tr>
                            <th>License Expiry</th>
                            <td>{moment(showdefault.associate_license_expiry_date).format("MM-DD-YYYY")}</td>
                          </tr>
                          {/* <tr>
                            <th>License Image</th>
                            <td>
                              <ShowSkyflowImage
                                table="users"
                                column="associate_license_image"
                                skyflowID={showdefault.skyflow_id}
                                elementID="associate_license_image"
                                style={{ width: "100px", height: "100px" }}
                              />
                            </td>
                          </tr> */}
                          <tr>
                            <th>License Serving Distance</th>
                            <td>{(showdefault.associate_serving_distance || "0") + " Miles"}</td>
                          </tr>
                          <tr>
                            <th>Bio</th>
                            <td>{showdefault.associate_bio}</td>
                          </tr>
                          <tr>
                            <th>Experience</th>
                            <td>{showdefault.associate_experience + " Years"}</td>
                          </tr>
                          {/* <tr>
                            <th>RN Verification</th>
                            <td className="text-capitalize">
                              <span className={`badge badge-pill ${verificationBadgeClass[showdefault?.associate_license_status] || "badge-secondary"}`}>
                                {showdefault?.associate_license_status ? t(showdefault.associate_license_status) : "pending"}
                              </span>
                            </td>
                          </tr> */}
                          <tr>
                            <th>{t("list_heading_created_date")}</th>
                            <td>{showdefault && showdefault.createdAt ? formatDateWithTime(showdefault.createdAt) : "N/A"}</td>
                          </tr>

                          {/* <tr>
                          <th>{t("list_heading_free_access")}</th>
                          <td>
                            {showdefault && showdefault.isFreeAccess}
                          </td>
                        </tr> */}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="row">
                      <p className="text-center">{t("label_no_data_found")}</p>{" "}
                    </div>
                  )}
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
              )}
            </div>

            <div className="mt-2 back-button mx-4">
              <button className="btn ripple btn-dark" type="button" onClick={() => navigate("/admin/babe-associate/list/1")}>
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BabeAssociateView;
